/* unplugin-vue-components disabled */import { render } from "./ViewFooter.vue?vue&type=template&id=942fb3ee"
import script from "./ViewFooter.vue?vue&type=script&lang=js"
export * from "./ViewFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__